import { Component, input, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass, DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { MatListItem } from '@angular/material/list';

@Component({
    selector: 'unite-list-item-read',
    templateUrl: './list-item-read.component.html',
    styleUrls: ['./list-item-read.component.scss'],
    imports: [MatListItem, NgClass, MatTooltip, MatIcon, TranslateModule, DecimalPipe, CurrencyPipe, DatePipe]
})
export class ListItemReadComponent {
  classItem = input('');
  classLabel = input('');
  classValue = input('');
  label = input<string>();
  required = input<false>();
  tooltip = input<string>();
  type = input<string>();
  value = input<string | number>();

  suffix = input<string>();
  suffixWithSpace = computed(() => {
    const value = this.suffix();
    return value && value.trim() !== '' ? value : null;
  });
}
